import { render } from "./Error.vue?vue&type=template&id=04b40f6a"
const script = {}

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__